
import NButton from '../buttons/NButton.vue';
import { EventTypes } from '../thumbnail/helpers/enums';
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { ThumbnailAction } from './types';
import NIcon from '../icons/NIcon.vue';
import NNotFoundImage from '../image/NNotFoundImage.vue';
import NLoadingDots from '../loading/NLoadingDots.vue';

@Options({
  name: 'NThumbnail',
  components: { NLoadingDots, NIcon, NButton, NNotFoundImage }
})
export default class NThumbnail extends Vue {
  @Prop({ type: Boolean })
  readonly loading: boolean = false;

  @Prop({ type: String, required: false })
  readonly modelValue!: string | null;

  @Prop({ type: String, default: 'extra-large' })
  readonly size!: 'small' | 'medium' | 'large' | 'extra-large';

  @Prop({ type: String, default: 'rounded' })
  readonly corners!: 'rounded' | 'circle';

  @Prop({ type: String, default: 'contain' })
  readonly fit!: 'cover' | 'contain';

  @Prop({ type: Array, default: [] })
  readonly actions!: ThumbnailAction[];

  @Prop({ type: String, default: 'click' })
  readonly defaultAction!: string;

  @Prop({ type: Boolean, default: false })
  readonly canClose!: boolean;

  @Prop({ type: String, required: false })
  readonly notFoundImageLabel?: string;

  loadingError = false;

  @Watch('modelValue')
  srcWatcher() {
    this.loadingError = false;
  }

  get computedNotFoundImageLabel() {
    return this.notFoundImageLabel ?? this.$t('errors.image.not_found');
  }

  get wrapClasses() {
    const result = [];
    if (this.size) result.push('n-thumbnail__' + this.size);
    if (this.corners) result.push('n-thumbnail__' + this.corners);
    return result;
  }

  get imageClasses() {
    const result = [];
    if (this.size) result.push('n-thumbnail__' + this.size);
    if (this.fit) result.push('n-thumbnail__image_' + this.fit);
    if (this.corners) result.push('n-thumbnail__' + this.corners);
    return result;
  }

  emitAction(actionName: string) {
    if (actionName === EventTypes.Select) {
      this.$emit(EventTypes.Select);
    } else {
      this.$emit('action', actionName);
    }
  }
}
